export default __webpack_public_path__ + "static/media/02.99419fd6.jpg";